var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 py-1"},[_c('span',{staticClass:"text-caption grey--text"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }